export default __webpack_public_path__ + "static/media/77_Agent_Thonburi_footer_order.e36bf007.png";